import { N500 } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { pluralize } from '@atlassian/mpac-utils';
import React from 'react';
import { DownloadIconContainer, InstallCountLoader, InstallCountTextV1, InstallCountTextV2, InstallCountWrapper } from './InstallCount.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const getPreinstalledMessage = (isPreinstalled, compatibleProducts, enableAppificationChanges) => {
  const productText = enableAppificationChanges ? 'Atlassian apps' : 'products';
  const marketplaceAppText = enableAppificationChanges ? 'Marketplace app' : 'app';
  if (!isPreinstalled) return null;
  let tooltipMessage = '';
  if (compatibleProducts.length === 1) {
    tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], " instances");
  } else if (compatibleProducts.length === 2) {
    tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], " and ").concat(compatibleProducts[1], " instances");
  } else if (compatibleProducts.length >= 3) {
    tooltipMessage = "This ".concat(marketplaceAppText, " comes preinstalled in ").concat(compatibleProducts[0], ", ").concat(compatibleProducts[1], " and other ").concat(productText);
  }
  return {
    tooltipMessage,
    showDownloadIcon: false,
    installCountMessage: 'Preinstalled',
    title: 'INSTALLS'
  };
};
const getNewAppMessage = (showNewAppMessage, showAetherAppListingPage) => {
  if (!showNewAppMessage) return null;
  return {
    tooltipMessage: null,
    installCountMessage: showAetherAppListingPage ? 'No installs yet' : 'New!',
    showDownloadIcon: false,
    title: 'INSTALLS'
  };
};
const getInstallCountMessage = (installCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage) => {
  if (!installCount || isPreinstalledInAnyHosting || isError) return null;
  const countInLocaleString = installCount.toLocaleString();
  return {
    tooltipMessage: "Customers have installed this app in at least ".concat(countInLocaleString, " active ").concat(pluralize('instance', installCount)),
    installCountMessage: "".concat(countInLocaleString, " ").concat(showAetherAppListingPage ? '' : pluralize('install', installCount)),
    showDownloadIcon: true,
    title: 'INSTALLS'
  };
};
const getDownloadCountMessage = (downloadCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage) => {
  if (!downloadCount || isPreinstalledInAnyHosting || isError) return null;
  const countInLocaleString = downloadCount.toLocaleString();
  return {
    tooltipMessage: "Customers have downloaded this app in at least ".concat(countInLocaleString, " active ").concat(pluralize('instance', downloadCount)),
    installCountMessage: "".concat(countInLocaleString, " ").concat(showAetherAppListingPage ? '' : pluralize('download', downloadCount)),
    showDownloadIcon: true,
    title: 'DOWNLOADS'
  };
};
export const useInstallMessage = _ref => {
  let {
    distribution,
    showNewAppMessage,
    compatibleProducts,
    enableAppificationChanges,
    showAetherAppListingPage
  } = _ref;
  const {
    installationCount,
    downloadCount,
    isPreinstalled,
    isPreinstalledInAnyHosting,
    isLoading,
    isError
  } = distribution || {};
  const {
    tooltipMessage,
    installCountMessage,
    showDownloadIcon,
    title
  } = getPreinstalledMessage(isPreinstalled, compatibleProducts, enableAppificationChanges) || getNewAppMessage(showNewAppMessage, showAetherAppListingPage) || getInstallCountMessage(installationCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage) || getDownloadCountMessage(downloadCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage) || {};
  return {
    tooltipMessage,
    installCountMessage,
    showDownloadIcon,
    isLoading,
    isError,
    title
  };
};
export const InstallCount = _ref2 => {
  let {
    showAetherAppListingPage,
    tooltipMessage,
    installCountMessage,
    showDownloadIcon,
    isLoading
  } = _ref2;
  if (installCountMessage == null) return null;
  if (isLoading) {
    return /*#__PURE__*/_jsx(InstallCountWrapper, {
      children: /*#__PURE__*/_jsx(InstallCountLoader, {
        "data-testid": "install-count-loader"
      })
    });
  }
  const InstallCountText = showAetherAppListingPage ? InstallCountTextV2 : InstallCountTextV1;
  return /*#__PURE__*/_jsx(Tooltip, {
    content: tooltipMessage,
    position: "bottom",
    children: /*#__PURE__*/_jsxs(InstallCountWrapper, {
      tabIndex: 0,
      role: "tooltip",
      children: [showDownloadIcon && /*#__PURE__*/_jsx(DownloadIconContainer, {
        label: installCountMessage,
        primaryColor: "var(--ds-icon-subtle, ".concat(N500, ")"),
        size: showAetherAppListingPage ? 'medium' : 'small'
      }), /*#__PURE__*/_jsx(InstallCountText, {
        children: installCountMessage
      })]
    })
  });
};
export default InstallCount;